import { Component, ViewChild } from '@angular/core';
import { ChartComponent, ApexOptions } from 'ng-apexcharts';
import { MatSelectChange } from '@angular/material/select';
import { predictiveMock } from '@reenstudio/app/core/mock/predictive/predictive.mock';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'app-period-bars',
  templateUrl: './period-bars.component.html',
  styleUrls: ['./period-bars.component.scss'],
})
export class PeriodBarsComponent {
  @ViewChild('chart') chart!: ChartComponent;
  public chartOptions: Partial<ApexOptions>;

  loading: boolean = false;

  consumato: SeriesItem[] = [];
  prodotto: SeriesItem[] = [];
  date: string[] = [];
  ora: number[] = [];
  series: SeriesItem[] = [];

  start = new Date();
  end = new Date();
  labelDate: string[] = [];

  selectedSite: string = '';

  constructor(private logger: NGXLogger) {
    this.end.setDate(this.start.getDate() + 7);
    this.createLabelDates();

    this.chartOptions = {
      // series: [],
      series: predictiveMock(),
      chart: {
        type: 'bar',
        height: 400,
        stacked: true,
        toolbar: {
          show: true,
        },
        zoom: {
          enabled: true,
        },
      },
      xaxis: {
        categories: this.labelDate,
        tickPlacement: 'true',
      },
      yaxis: {
        labels: {
          formatter: (val) => {
            return (+val / 1000).toFixed(0) + 'kWh';
          },
        },
      },
      plotOptions: {
        bar: {
          columnWidth: '80%',
        },
      },
      legend: {
        show: false,
        showForSingleSeries: false,
        showForNullSeries: false,
        showForZeroSeries: false,
      },
      dataLabels: {
        enabled: false,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return (+val / 1000).toFixed(0) + 'kWh';
          },
        },
      },
    };
  }

  getData(site: string) {
    let DefaultStartDate = new Date();
    DefaultStartDate.setDate(DefaultStartDate.getDate() - 7);
    const DefaultEndDate = new Date();

    this.loading = true;
    this.prodotto = [];
    this.consumato = [];
    this.date = [];
    this.ora = [];
  }

  changeSite(site: MatSelectChange) {
    this.getData(site.value);
  }

  createLabelDates() {
    const currentDate = new Date();
    for (let i = 0; i < 7; i++) {
      const nextDate = new Date(currentDate);
      nextDate.setDate(currentDate.getDate() + i);
      this.labelDate.push(nextDate.toLocaleDateString());
    }
  }
}

interface SeriesItem {
  name: string;
  group: string;
  data: number[];
}
